import { api } from './api'

import StorageService from './StorageService'

import { meta as appModulesMeta } from '@modules/index'

let instance = null

export default class AuthService {
  storage = null;
  synced = false;

  constructor () {
    if (!instance) {
      this.storage = new StorageService('Auth')
      instance = this
    }

    return instance
  }

  redirectToSignIn () {
    if (location.pathname !== '/') {
      location.pathname = '/'
    }
  }

  clearAuthData () {
    this.storage.clear()
  }

  getAuthData () {
    return this.storage.all()
  }

  async requestNewToken ({ refresh }) {
    try {
      const { data } = await api.post('/auth/refresh', {
        token: refresh
      })
      this.storage.setItem('token', data.refresh)
      this.storage.setItem('refresh', data.refresh)
    } catch (e) {
      this.signOut()
    }
  }

  async updateAuthData ({ data, unit_id, module_id }) {
    data.user.units = data.user.units.map((unit) => {
      unit.modules = unit.modules.map((module) => {
        module.meta = appModulesMeta[module.name]
        return module
      })

      return unit
    })

    data.unit =
      data.user.units.find((unit) => unit.id === unit_id) ||
      data.user.units.find(Boolean)

    data.module = data.unit?.modules?.find(
      (module) => module.id === module_id
    ) || data.unit?.modules?.find(Boolean)

    this.storage.setItem('token', data.access_token)
    this.storage.setItem('refresh', data.refresh_token)
    this.storage.setItem('user', data.user)
    this.storage.setItem('unit', data.unit)
    this.storage.setItem('module', data.module)

    return data
  }

  async signIn ({ login, password }) {
    this.synced = true

    const { data } = await api.post('/auth/login', {
      login,
      password
    })

    return this.updateAuthData({ data })
  }

  async syncUserData () {
    if (this.synced) return

    const authorization = this.getToken()

    const { id: unit_id } = this.getUnit() || {}
    const { id: module_id } = this.getModule() || {}

    return authorization ? this.authByToken({
      authorization,
      unit_id,
      module_id
    }) : {}
  }

  async authByToken ({ authorization, unit_id, module_id }) {
    this.synced = true

    const { data } = await api.get('/auth/user', {
      headers: { Authorization: `Bearer ${authorization}` }
    })

    return this.updateAuthData({ data, unit_id, module_id })
  }

  signOut () {
    this.clearAuthData()
    this.redirectToSignIn()
  }

  setToken (data) {
    this.storage.setItem('token', data)
  }

  setRefresh (data) {
    this.storage.setItem('refresh', data)
  }

  setUser (data) {
    this.storage.setItem('user', data)
  }

  setUnit (data) {
    this.storage.setItem('unit', data)
  }

  setModule (data) {
    this.storage.setItem('module', data)
  }

  getToken () {
    return this.storage.getItem('token')
  }

  getRefresh () {
    return this.storage.getItem('refresh')
  }

  getUser () {
    return this.storage.getItem('user')
  }

  getUnit () {
    return this.storage.getItem('unit')
  }

  getModule () {
    return this.storage.getItem('module')
  }
}
